/*global $ */

const initializeTooltip = () => {
  document.querySelectorAll('[data-toggle="tooltip"]').forEach((element) => {
    $(element).tooltip({
      container: "body",
    });
  });
};

const initializePopover = () => {
  document.querySelectorAll('[data-toggle="popover"]').forEach((element) => {
    $(element).popover({
      container: "body",
    });
  });
};

const initializeHoverHelpers = () => {
  initializeTooltip();
  initializePopover();
};

window.addEventListener("load", initializeHoverHelpers);

// When replacing content with turo stream we won't trigger a full page reload
// so we need to reinitialize the tooltips and popovers. This event is triggered
// before the new content is rendered. We wait a bit to make sure the new
// content is in the DOM before initializing them.
document.addEventListener("turbo:before-stream-render", () => {
  setTimeout(initializeHoverHelpers, 10);
});
document.addEventListener("turbo:before-render", () => {
  setTimeout(initializeHoverHelpers, 10);
});
